// Chakra imports
import { Box, Flex, Select, Text } from '@chakra-ui/react';
// Custom components
import CardMy from 'components/CardMy';
import Title from 'components/CardMy/Title';
import Label from 'components/Label';
import PieChart from 'components/charts/PieChart';
import { IoCall } from 'react-icons/io5';
import { pieChartData, pieChartOptions } from 'variables/charts';

const Item = ({ color, text, value }: any) => (
    <Flex
        borderColor="gray.100"
        borderWidth="1px"
        borderRadius="8px"
        paddingX="16px"
        height="48px"
        alignItems="center"
        gap="8px"
    >
        <Label text={text} color={color} />
        <Text fontSize="md" fontWeight="700" color="gray.900" pl="20px" ml="auto">
            {value}%
        </Text>
    </Flex>
);

export default function CallDespositions() {
    return (
        <CardMy>
            <Flex flexWrap="wrap" justifyContent="space-between" alignItems="center" w="100%" mb="20px">
                <Title icon={IoCall}>Call Dispositions</Title>
                <Select
                    height="20px"
                    fontSize="sm"
                    variant="subtle"
                    defaultValue="monthly"
                    width="unset"
                    fontWeight="400"
                >
                    <option value="daily">Daily</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                </Select>
            </Flex>
            <Flex w="100%" justifyContent="space-between">
                <Flex flexDirection="column" gap="4px" flexShrink="0">
                    <Item color={pieChartOptions.colors[0]} text="No Answer" value={63} />
                    <Item color={pieChartOptions.colors[1]} text="Set" value={25} />
                </Flex>
                <Box pos="relative" marginRight="-24px" marginBottom="-20px">
                    <PieChart chartData={pieChartData} chartOptions={pieChartOptions} />
                </Box>
            </Flex>
            {/* <Card
                bg={cardColor}
                flexDirection="row"
                boxShadow={cardShadow}
                w="100%"
                p="15px"
                px="20px"
                mt="15px"
                mx="auto"
            >
                <Flex direction="column" py="5px">
                    <Flex align="center">
                        <Box h="8px" w="8px" bg="brand.500" borderRadius="50%" me="4px" />
                        <Text fontSize="xs" color="secondaryGray.600" fontWeight="700" mb="5px">
                            Your files
                        </Text>
                    </Flex>
                    <Text fontSize="lg" color={textColor} fontWeight="700">
                        63%
                    </Text>
                </Flex>
                <VSeparator mx={{ base: '60px', xl: '60px', '2xl': '60px' }} />
                <Flex direction="column" py="5px" me="10px">
                    <Flex align="center">
                        <Box h="8px" w="8px" bg="#6AD2FF" borderRadius="50%" me="4px" />
                        <Text fontSize="xs" color="secondaryGray.600" fontWeight="700" mb="5px">
                            System
                        </Text>
                    </Flex>
                    <Text fontSize="lg" color={textColor} fontWeight="700">
                        25%
                    </Text>
                </Flex>
            </Card> */}
        </CardMy>
    );
}
